// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"HistoryItemAvatar__avatarWrapper___cZAO8"};